
const digest = 'e0c712568d9fef36bdfcbb1a35722c9b5faa6b6573dabbf287dd47f0a9e0d5ec';
const classes = {"wrapper":"_wrapper_19gnr_1"};
const css = `._wrapper_19gnr_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  